const loadMorePosts = () => {

  const loadMorebutton = document.querySelector('.jsloadmore');
  const postListContainer = document.querySelector('.postlist');

  if (loadMorebutton) {

    let paged = loadMorebutton.getAttribute('data-paged');

    loadMorebutton.addEventListener('click', () => {

      postType = loadMorebutton.getAttribute('data-posttype');
      term = loadMorebutton.getAttribute('data-term');
      showRelatedPosttype = loadMorebutton.getAttribute('data-showRelatedPosttype');
      loadMorebutton.classList.toggle('hide');

      let formData = new FormData();
      formData.append("action", "park_load_more");
      formData.append("postType", postType);
      formData.append("term", term);
      formData.append("paged", paged);
      formData.append("showRelatedPosttype", showRelatedPosttype);
      formData.append("query", "");

      fetch(archeologiedagen_js_vars.url, {
        method: 'POST',
        body: formData
      })

        .then((response) => response.json())
        .then((data) => {
          if (data) {
            postListContainer.insertAdjacentHTML('beforeend',data.data.html);
            setupSiteHeaderBackground();
            if (data.data.maxNumPages > paged) {
              paged++;
              loadMorebutton.classList.toggle('hide');
            }
          }
        });
    });
  }
};

loadMorePosts();